export default __webpack_public_path__ + "static/media/038-flying chairs.190ffeaf.svg";